export { default } from './ModalComponent';
